<template>
  <b-input-group
    :prepend="prefix"
    :append="suffix"
    class="relative"
    :class="errors.length > 0 ? 'is-invalid' : null"
  >
    <b-form-input
      class="form-control"
      :value="value"
      :disabled="true"
      :placeholder="placeholder"
      @input="input"
    />
    <div
      v-if="showColorPlaceholder"
      :style="{
        position: 'absolute',
        top: '50%',
        left: '42.5%',
        transform: 'translateY(-50%)',
        width: '45px',
        height: '15px',
        borderRadius: '4px',
        backgroundColor: value
      }"
    />
    <b-input-group-append>
      <b-button variant="primary" @click.stop="toggleColorPicker">
        <feather-icon icon="Edit2Icon" v-if="!showPicker" />
        <feather-icon icon="XIcon" v-else />
      </b-button>
    </b-input-group-append>
    <div ref="colorPicker" class="float-color-picker">
      <sketch :value="color" @input="updateValue" v-show="showPicker" />
    </div>
  </b-input-group>
</template>

<script>
import {
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
} from "bootstrap-vue";
import { Sketch } from "vue-color";
import { bus } from "@/libs/bus";

export default {
  name: 'ColorPicker',

  components: {
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    Sketch,
  },

  props: {
    showColorPlaceholder: {
      type: Boolean,
      default: false,
    },
    placeholder: {},
    name: {},
    disabled: {},
    value: {},
    prefix: {
      default: "",
    },
    suffix: {
      default: "",
    },
    errors: {
      type: Array,
      default: () => [],
    },
    // Add unique identifier for each picker
    pickerId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      showPicker: false,
      color: {
        hex: "",
      },
    };
  },

  watch: {
    value(value) {
      if (this.color.hex !== value) {
        this.color.hex = value;
      }
    },
  },

  created() {
    // Listen for other color pickers being opened
    bus.$on('color-picker-opened', this.handleOtherPickerOpened);
  },

  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },

  beforeDestroy() {
    // Clean up all event listeners
    document.removeEventListener('click', this.handleClickOutside);
    bus.$off('color-picker-opened', this.handleOtherPickerOpened);
  },

  methods: {
    updateValue(value) {
      this.input(value.hex);
    },

    input(value) {
      this.$emit("input", value);
      this.$emit("change", value);
    },

    toggleColorPicker() {
      this.showPicker = !this.showPicker;

      if (this.showPicker) {
        // Notify other pickers that this one is opening
        bus.$emit('color-picker-opened', this.pickerId);

        if (this.$refs.colorPicker) {
          this.$refs.colorPicker.scrollIntoView({
            block: "center",
            behavior: "smooth",
          });
        }
      }
    },

    handleClickOutside(event) {
      if (
        this.showPicker &&
        this.$refs.colorPicker &&
        !this.$refs.colorPicker.contains(event.target)
      ) {
        this.showPicker = false;
      }
    },

    handleOtherPickerOpened(openedPickerId) {
      // Close this picker if another one is opened
      if (openedPickerId !== this.pickerId && this.showPicker) {
        this.showPicker = false;
      }
    }
  },
};
</script>

<style scoped>
.float-color-picker {
  position: absolute;
  z-index: 1000;
  margin-top: 5px;
}

.relative {
  position: relative;
}
</style>